'use client'
import { InputLeftElement as ChakraInputLeftElement } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { InputLeftElementProps } from './InputLeftElement.types'

export default forwardRef(function Input(
  props: InputLeftElementProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraInputLeftElement {...props} ref={ref} translate="no" />
})
